module.exports = __webpack_public_path__ + "media/images/front/event_publish_lp/mv_01-4f523b1d0ffc5faab1b8dd70d4bd912b.jpg";